import { api } from '@/helpers/api'

export default {
  state: {
    UNKNOWN_NUMBER: 0,
    WRONG_BIRTHDATE: 1,
    EMAIL_NOT_MATCHING: 2
  },
  get (number) {
    return api.get('legacy/api/v1/portal/partner/' + number).then(response => {
      return Promise.resolve(response.data)
    })
  },
  set (number, data) {
    return api.put('legacy/api/v1/portal/partner/' + number, data)
  },
  getPolicies (number) {
    return api.get('legacy/api/v1/portal/partner/policies/' + number).then(response => {
      return Promise.resolve(response.data)
    })
  },
  async getImage () {
    try {
      const res = await api.get('upload/private?key=avatar')
  
      return res.data
    } catch {
      return { data: '' }
    }
  },
  async setImage (data) {
    try {
      const res = await api.post('upload/private', { key: 'avatar', data })
  
      return res.data
    } catch {
      return { data: '' }
    }
  },
  checkNumber (number) {
    return api.get('legacy/api/v1/portal/partner/checkNumber/' + number).then(response => {
      return Promise.resolve(response.data)
    }).catch(error => {
      if (error.request.status === 404) {
        return Promise.reject(this.state.UNKNOWN_NUMBER)
      } else {
        return Promise.reject(error)
      }
    })
  },
  checkBirthdate (number, date) {
    return api.get('legacy/api/v1/portal/partner/checkBirthDate/' + number + '/' + date).catch(error => {
      if (error.request.status === 404) {
        return Promise.reject(this.state.WRONG_BIRTHDATE)
      } else {
        return Promise.reject(error)
      }
    })
  },
  changeEmail (number, oldemail, newemail) {
    let data = {
      email: newemail,
      partner_email: oldemail
    }

    return api.put('legacy/api/v1/portal/partner/email/' + number, data).catch(error => {
      if (error.request.status === 412) {
        return Promise.reject(this.state.EMAIL_NOT_MATCHING)
      } else {
        return Promise.reject(error)
      }
    })
  }
}